export const TransConf = {
    marketing_task_index_list_show: {
        name: 'marketing_task_index_list_show',
        sampleRate: 0.1,
    },
};
export const allAllowedTags = new Set([
    'moduleName',
]);
